export const sidebarWidth = 260;
export const toolbarHeight = 64;
